export const getAccessToken = (state: any) => state.tokenHandling.accessToken ?? 'NO_ACCESS_TOKEN_AVAILABLE';

export const getIdToken = (state: any) => state.tokenHandling.idToken;
